module.exports = __webpack_public_path__ + "img/help.fc516ef5.svg";